module.exports = __webpack_public_path__ + "media/bootstrap-icons/diamond-half-b94a9fb8.svg";